import {useEffect, useRef, useState} from 'react'
import Area from "../../Public/Elements/Area/Area";
import {useFormik} from "formik";
import * as yup from "yup";
import Button from "../../../components/Button/Button";
import classNames from "classnames";
import {useNavigate} from "react-router-dom";
import PublicModal from "../PublicModal/PublicModal";
import * as publicFormActions from "../PublicActions/PublicActions";
import "./PublicFormDisplay.scss"
import {jsPDF} from "jspdf";
import html2canvas from "html2canvas";

function PublicFormDisplay({
                               formName,
                               requiresSignature,
                               publicId,
                               publicCustomerId,
                               allFormsPublicId,
                               savedVariables,
                               savedData,
                               rootItems,
                               droppedItems
                           }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allRequiredFilled, setAllRequiredFilled] = useState(false);
    const [requiredFields, setRequiredFields] = useState([]);
    const [validationShape, setValidationShape] = useState({});
    const [variablesInfo, setVariablesInfo] = useState([]);
    const [initialValues, setInitialValues] = useState({});
    const [uploadedFile, setUploadedFile] = useState([]);
    const navigate = useNavigate();
    const publicFormRef = useRef(null);
    let childrenItems = [];
    let counter = 0;

    const handleDownload = () => {
        html2canvas(publicFormRef.current).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const width = pdf.internal.pageSize.getWidth();
            const height = (canvas.height * width) / canvas.width;
            pdf.addImage(imgData, 'PNG', 0, 2, width, height);
            pdf.save(formName + ".pdf");
        });
    }

    const createValidationSchema = (droppedItem, formikName) => {
        const required = droppedItem.settings.required;
        const requiredMessage = `${droppedItem.settings.title} is a required field`;
        let dedicatedSchema;

        if (droppedItem.settings.title === "E-mail")
            dedicatedSchema = required
                ? yup.string().required(requiredMessage).email("Invalid e-mail address")
                : yup.string().email("Invalid e-mail address");
        else if (droppedItem.settings.title === "Phone number")
            dedicatedSchema = required
                ? yup.string().required(requiredMessage).matches(/^[0-9]{9}$/, `Phone number can only contain 9 numbers`)
                : yup.string().matches(/^[0-9]{9}$/, `Phone number can only contain 9 numbers`);
        else if (droppedItem.settings.title === "Postal code")
            dedicatedSchema = required
                ? yup.string().required(requiredMessage).matches(/^\d{2}[-]\d{3}$/, `Postal code can only contain numbers and "-"`)
                : yup.string().matches(/^\d{2}[-]\d{3}$/, `Postal code can only contain  numbers and "-"`);
        else if (droppedItem.settings.inputType === "signature")
            dedicatedSchema = required
                ? yup.string().required(requiredMessage).matches(/.pdf/)
                : yup.string().matches(/.pdf/);
        else if (droppedItem.settings.inputType === "number")
            dedicatedSchema = required
                ? yup.number().required(requiredMessage)
                : yup.number()
        else if (droppedItem.settings.inputType === "checkbox")
            dedicatedSchema = required
                ? yup.string().required(requiredMessage).matches(/^(false|true)$/)
                : yup.string().matches(/^(false|true)$/)
        else
            dedicatedSchema = required ? yup.string().required(requiredMessage) : yup.string();

        if (required) setRequiredFields(prev => [...prev, formikName])

        setValidationShape(prev => ({...prev, [formikName]: dedicatedSchema}));
    }

    useEffect(() => {
        droppedItems.map((droppedItem) => {
            if (droppedItem.settings.title) {
                let initialValue = "";
                const formikName = droppedItem.settings.inputType === "radio" ? droppedItem.settings.selectedRadioGroup.value : droppedItem.id;

                if (savedData?.hasOwnProperty(formikName))
                    initialValue = savedData[formikName];
                else if (droppedItem.settings.hasVariable && savedVariables != null && savedVariables.hasOwnProperty(droppedItem.settings.title))
                    initialValue = savedVariables[droppedItem.settings.title]
                else if (droppedItem.settings.inputType === "checkbox")
                    initialValue = "false";
                else if (droppedItem.settings.inputType === "signature")
                    initialValue = formName + ".pdf";

                setInitialValues(prev => ({...prev, [formikName]: initialValue}))

                createValidationSchema(droppedItem, formikName);

                if (droppedItem.settings.hasVariable) setVariablesInfo(prev => [...prev, {
                    id: formikName,
                    title: droppedItem.settings.title
                }]);
            }
        })
    }, [droppedItems]);

    const validationSchema = yup.object().shape(validationShape);

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnChange: true,
        onSubmit: (values) => {
            if (requiresSignature && !isModalOpen) {
                setIsModalOpen(true);
                handleDownload();
            } else {
                const variables = savedVariables != null ? savedVariables : {};

                variablesInfo.map(variable =>
                    variables[variable.title] = values[variable.id]
                )

                const formData = new FormData();
                if (uploadedFile) formData.append("file", uploadedFile[0]);

                const customerFormRequest = new Blob([JSON.stringify({
                    "publicCustomerId": publicCustomerId,
                    "data": values,
                    variables
                })], {type: 'application/json'});

                formData.append("customerFormRequest", customerFormRequest)

                publicFormActions.updateCustomerFormData(publicId, formData, (result) => {
                    if (result.success) {
                        navigate(`/${allFormsPublicId}`);
                    }
                })
            }
        },
    });

    useEffect(() => {
        let valid = formik.isValid;

        for (let i = 0; i < requiredFields.length; i++) {
            if (formik.values[requiredFields[i]] === undefined || formik.values[requiredFields[i]] === "") {
                valid = false;
                break;
            }
        }
        setAllRequiredFilled(valid);
    }, [requiredFields, formik.values, formik.errors])

    const handleCancel = () => {
        navigate(`/${allFormsPublicId}`)
    }

    const handleOnClose = () => {
        setIsModalOpen(false);
        setUploadedFile([]);
    }

    return (
        <div className="public-form-display">
            <form noValidate id="public-form" ref={publicFormRef} onSubmit={formik.handleSubmit}>
                {rootItems.map(item => {
                    if (!item) return null;

                    if (counter === 0) {
                        childrenItems = [];
                    }

                    const areaType = item.settings.areaType.split("-")[1];
                    const childItems = droppedItems.filter(child => child?.parentId === item.id);

                    childrenItems.push(childItems);

                    if ((areaType === "double" && counter === 0) || (areaType === "triple" && counter === 2)) {
                        counter = 1;
                        return;
                    } else if (areaType === "triple" && counter === 0) {
                        counter = 2;
                        return;
                    }

                    counter = 0;

                    return (
                        <div className="item" key={item.id}>
                            <Area
                                formik={formik}
                                settings={item.settings}
                                childrenItems={childrenItems}
                            />
                        </div>
                    )
                })}
                {isModalOpen &&
                    <PublicModal
                        isOpen={true}
                        uploadedFile={uploadedFile}
                        setUploadedFile={setUploadedFile}
                        onClose={handleOnClose}
                    />
                }
            </form>
            <div className="buttons">
                <Button
                    variant={classNames({
                        "primary": allRequiredFilled,
                        "disabled": !allRequiredFilled,
                        "requiresSignature": requiresSignature
                    })}
                    disabled={!allRequiredFilled}
                    type="submit"
                    form="public-form"
                >
                    {requiresSignature ? "Download and sign" : "Save"}
                </Button>

                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
            </div>
        </div>
    )
}

export default PublicFormDisplay
